export const LESSEE_DISEASE = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加承租人意外伤害或疾病租房押金损失保险条款',
    register_number: '（注册号：C00001032122019071502071）',
    protocols: [
        {
            intro: '保险责任',
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，经过保险单载明的等待期（除另有约定外，等待期为30天，续保的无等待期）后，被保险人遭受意外伤害事故或罹患疾病，在中华人民共和国境内（不含港澳台地区，下同）二级以上（含二级）医院或者保险人指定或认可的医疗机构住院治疗，且住院治疗天数达到或超过保险单载明的起赔天数（除另有约定外，起赔天数为25天），导致被保险人被迫在房屋租赁合同约定的租期终止之日之前发生退租，因此发生的被保险人根据房屋租赁合同的约定无法全部或部分退回的租房押金的损失，保险人按照本合同的约定负责赔偿。'
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第二条',
                    context: '下列任何原因造成的损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险人违反房屋租赁合同，擅自改变房屋租赁合同约定的租赁用途；' },
                        { text: '（二）被保险人利用租住的房屋进行违法活动。 '}
                    ]
                },
                {
                    order: '第三条',
                    context: '下列原因造成的损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）投保人、被保险人或其家庭成员的故意行为、重大过失行为；' },
                        { text: '（二）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动； '},
                        { text: '（三）核辐射、核爆炸、核污染及其他放射性污染； ' },
                        { text: '（四）地震、海啸及其次生灾害； ' },
                        { text: '（五）行政行为或司法行为；' } ,
                        { text: '（六）大气污染、土地污染、水污染及其他各种污染；' },
                        { text: '' }
                    ]
                },
                {
                    order: '第四条',
                    context: '下列损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）以租房押金扣抵税费或债务的部分；' },
                        { text: '（二）保险单载明的免赔额或按照保险单载明的免赔率计算的免赔额；' },
                        { text: '（三）其他不属于本保险责任范围内的损失、费用。' }
                    ]
                }
            ]
        },
        {
            intro: '保险金额和免赔额（率）',
            list: [
                {
                    order: '第五条',
                    context: '保险金额由投保人与保险人双方协商确定，并在保险单中载明。'
                },
                {
                    order: '第六条',
                    context: '每次事故的免赔额（率）由投保人与保险人协商确定，并在保险单中载明。'
                }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                {
                    order: '第七条',
                    context: '发生保险责任范围内的损失时，保险人按照被保险人实际遭受的租房押金损失，在扣除每次事故免赔额或按照保险单载明的每次事故免赔率计算的免赔额后进行赔偿，最高不超过保险金额或被保险人根据房屋租赁合同已实际支付的租房押金金额，两者以低者为准。'
                }
            ]
        },
        {
            intro: '其他事项',
            list: [
                { order: '第八条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' }
            ]
        }
    ]
}